import React from 'react';
import PropTypes from 'prop-types';

import DisplayRichContent from '../../../global/components/forms/DisplayRichContent';
import ContentModuleCard2 from '../../contentModule/components/ContentModuleCard2';

import { checkIfRichText } from '../../../global/utils/richContentUtils';
import LandingTemplateFooter from './LandingTemplateFooter';
import StyledButton from 'shared-resources/components/src/StyledButton';

// proof of concept for a public landing page template
const PublicLandingTemplate3 = ({ templateConfig, contentModules = [], handleOpenModule, handleLoginClick, handleSignupClick,isLoggedIn, groupRegistrationAccess, isGroupMember }) => {
  const {
    logoUrl1
    , heroUrl1
    , heroUrl2
    , header1
    , subHeader1
    , body1
    , body2
    , embedContent
    , footer
    , footerLogoUrl
    , footerCaption
    , persistentFooter
    , persistentFooterLogoUrl
    , displayModuleDescriptions
    , showPfLogo
    , allowLogin
    , allowSignup
    , externalCallToActionUrl
    , externalCallToActionLabel
  } = templateConfig || {};

  const defaultTextClass = '!text-pf-black-800';

  return (
    <div className="h-full min-h-fit mx-auto bg-pf-white rounded-sm">
      {/* Header Section */}
      <header className="flex justify-between py-4 md:mx-2 items-center border-gray-300" id='header-top'>
        {logoUrl1 ?
          <div className="mr-8">
            <img src={logoUrl1} alt="Client Logo" className="h-8 w-auto object-scale-down " />
          </div>
          :
          <div className="">
            <img src={"https://pro-ficiency-static.s3.us-east-2.amazonaws.com/atlas/slp_full_blue.png"} alt="Client Logo" className="h-8 w-auto object-scale-down" />
          </div>
        }
        {allowLogin && (
          <div className="flex gap-4">
            {!isLoggedIn ? 
              <div className="flex gap-4">
                <StyledButton
                  variant='primary'
                  size='sm'
                  onClick={handleLoginClick}
                >
                  {'Login'}
                </StyledButton>
                {allowSignup && groupRegistrationAccess && (
                  <StyledButton
                    variant='tertiary'
                    size='sm'
                    onClick={handleSignupClick}
                  >
                    Sign Up
                  </StyledButton>
                )}
              </div>
            : isLoggedIn && isGroupMember ? // should View Dashboard button always show if logged in? reglardless of group membership? 
              <StyledButton
                variant='primary'
                size='sm'
                onClick={handleLoginClick}
              >
                {'View Dashboard'} 
              </StyledButton>
            : isLoggedIn && !isGroupMember && allowSignup && groupRegistrationAccess ?
              <StyledButton
                variant='tertiary'
                size='sm'
                onClick={handleSignupClick}
              >
                Join Group
              </StyledButton>
            : null 
            }
            {externalCallToActionUrl && externalCallToActionLabel ? (
              <StyledButton
                variant='secondary'
                size='sm'
                href={externalCallToActionUrl}
              >
                {externalCallToActionLabel}
              </StyledButton>
            ) : null}
          </div>
        )}
      </header>
      {/* Main Content */}
      <div className={`${defaultTextClass} flex flex-col min-h-screen gap-8 md:gap-10`} id="main-content">
        {/* Hero Section */}
        {(heroUrl1 || header1 || body1 || subHeader1) && (
          <section className="-mx-4 sm:-mx-20">
            {heroUrl1 ?
              <div className="relative w-full min-h-fit bg-gray-100">
                <img src={heroUrl1} alt="Hero Image" className="w-full max-h-full h-[470px] object-cover object-left" />
                {header1 || subHeader1 ?
                  <>
                    <div className="absolute bottom-20 sm:bottom-20 sm:top-auto left-5 right-5 md:left-20 md:right-20  md:w-3/4 lg:w-1/2">
                      <div>
                        {header1 && <p className="text-4xl w-full md:w-1/2 md:text-5xl !text-pf-white font-semibold p-2 mb-3">{header1}</p>}
                        {subHeader1 && <p className="text-base w-full sm:w-1/2 md:w-3/4 !text-pf-white font-base px-2">{subHeader1}</p>}
                      </div>
                      {externalCallToActionUrl && externalCallToActionLabel ?
                        <StyledButton
                          variant='secondary'
                          className='mt-6 w-full md:w-fit px-16 rounded-md'
                          href={externalCallToActionUrl}
                        >
                          {externalCallToActionLabel}
                        </StyledButton>
                        : null
                      }
                    </div>
                  </>
                  : null
                }
              </div>
              : header1 || subHeader1 ?
                <div className="px-10 pb-10 w-full md:w-3/4">
                  {header1 && <h2 className="text-5xl font-semibold ">{header1}</h2>}
                  {subHeader1 && <p className="text-base font-semibold ">{subHeader1}</p>}
                </div>
                : null
            }
          </section>
        )}
        {/* Body1 Section */}
        {checkIfRichText(body1) &&
          // <div className="px-4 py-6 md:px-20 md:py-14 -mt-8 md:-mt-10 -mx-4 sm:-mx-20 bg-pf-white">
          <div className="md:py-6 bg-pf-white flex flex-col md:flex-row md:gap-10 sm:gap-4 w-full">
            {heroUrl2 ?
              <div className="w-full lg:w-1/2">
                <img src={heroUrl2} alt="Hero Image" className="w-full h-[350px] object-contain md:object-fit" />
              </div>
              : null
            }
            <div className="w-full md:w-1/2">
              <div className="h-full flex flex-col justify-center">
                <div className="">
                  <DisplayRichContent className="border-none" content={body1} />
                  {externalCallToActionUrl && externalCallToActionLabel ?
                    <StyledButton
                      variant='primary'
                      size='sm'
                      className='mt-6 w-full md:w-fit px-16 rounded-md'
                      href={externalCallToActionUrl}
                    >
                      {externalCallToActionLabel}
                    </StyledButton>
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        }
        {/* Body2 Section */}
        {checkIfRichText(body2) &&
          <div className="px-4 py-6 md:px-20 md:py-14 -mx-4 sm:-mx-20 bg-[#F8F8F8]">
            <DisplayRichContent className="border-none" content={body2} />
            {externalCallToActionUrl && externalCallToActionLabel ?
              <StyledButton
                variant='primary'
                className='mt-6 w-full md:w-fit px-16 rounded-md'
                href={externalCallToActionUrl}
              >
                {externalCallToActionLabel}
              </StyledButton>
              : null
            }
          </div>
        }
      </div>
      {/* Footer Section */}
      <LandingTemplateFooter
        footer={footer}
        footerLogoUrl={footerLogoUrl}
        footerCaption={footerCaption}
        persistentFooter={persistentFooter}
        persistentFooterLogoUrl={persistentFooterLogoUrl}
        showPfLogo={showPfLogo}
      />
    </div>
  );
};

PublicLandingTemplate3.propTypes = {
  templateConfig: PropTypes.shape({
    logoUrl1: PropTypes.string
    , heroUrl1: PropTypes.string
    , header1: PropTypes.string
    , subHeader1: PropTypes.string
    , body1: PropTypes.object
    , embedContent: PropTypes.bool
    , footer1: PropTypes.object
    , allowLogin: PropTypes.bool
  })
  , searchParams: PropTypes.object
  , moduleLinks: PropTypes.array
  , contentModules: PropTypes.array
  , handleOpenModule: PropTypes.func
};



export default PublicLandingTemplate3;